/*
 * Schnellauswahl auf den Kollektionsseiten (Rückmeldung Kevin + Joshua 10.08.2026).
 * Gleiche Bedienlogik wie konfigurator.js: data-wahl-Knöpfe, Live-Preis, /cart/add.js.
 * Datenquelle ist window.ROST_SCHNELL (SKU -> ID, Preis in Cent, verfügbar) aus dem
 * Snippet schnellauswahl.liquid. Die SKU-Bildner müssen exakt zu produkte_bauen.py
 * passen; fehlt eine SKU, wird die Kombination gar nicht erst angeboten.
 *
 * Relaunch 19.09.2026: Höhe als Kacheln (Matten, Pfosten). Das Auswahlfeld
 * data-feld="hoehe" bleibt die eine Quelle der Wahrheit, die Kacheln spiegeln es nur
 * (siehe hoehenKacheln). SKU-Bildner, Verfügbarkeit und Warenkorb-Aufruf sind unverändert.
 * Geldformat: Intl de-DE, Ausgabe „1.234,56 €“ (gleich in warenkorb.js und konfigurator.js).
 */
(function () {
  "use strict";

  var DATEN = window.ROST_SCHNELL || { art: "", varianten: {} };
  var V = DATEN.varianten || {};
  var BILDER = window.ROST_BILDER || {};

  var HOEHEN = [630, 830, 1030, 1230, 1430, 1630, 1830, 2030];
  var FARB_KUERZEL = { "Anthrazit": "ANT", "Moosgrün": "MOO", "Verzinkt": "VER", "Fenstergrau": "FEN" };
  var FARB_SLUG = { "Anthrazit": "anthrazit", "Moosgrün": "moosgruen", "Verzinkt": "verzinkt", "Fenstergrau": "fenstergrau" };
  var MONTAGE_KUERZEL = { "Einbetonieren": "EIN", "Aufdübeln": "AUF" };
  var STAERKE_KUERZEL = { "6/5/6": "656", "8/6/8": "868" };
  var FORM_KUERZEL = { "Genarbt": "GEN", "Gerillt": "GER" };

  var euro = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  var geld = function (cent) { return euro.format(cent / 100); };
  // Varianten-Namen und Fehlermeldungen kommen von außen (Shopify-Daten, Cart-API) -
  // vor innerHTML immer escapen (Verifikator-Befund 10.08.2026).
  function esc(text) {
    return String(text == null ? "" : text).replace(/[&<>"']/g, function (z) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[z];
    });
  }

  function verf(sku) { return V[sku] && V[sku].verfuegbar ? V[sku] : null; }

  /* ---------- SKU-Bildner je Artikelart ---------- */
  // Zaunfeld: EIN wird bevorzugt, AUF ist nur Rundungs-Fallback (bis 1 Cent Differenz in der CSV).
  function skuMatte(staerke, hoehe, farbe) {
    var basis = "ZF-" + STAERKE_KUERZEL[staerke] + "-" + hoehe + "-" + FARB_KUERZEL[farbe] + "-";
    return verf(basis + "EIN") ? basis + "EIN" : (verf(basis + "AUF") ? basis + "AUF" : null);
  }
  // Pfosten: Drahtstärke ist preisgleich (656/868), Montageart NICHT - die bleibt Wahl des Kunden.
  function skuPfosten(typ, hoehe, farbe, montage) {
    var praefix = typ === "Eckpfosten" ? "EP" : "AP";
    var staerken = ["656", "868"];
    for (var i = 0; i < staerken.length; i++) {
      var sku = praefix + "-" + staerken[i] + "-" + hoehe + "-" + FARB_KUERZEL[farbe] + "-" + MONTAGE_KUERZEL[montage];
      if (verf(sku)) return sku;
    }
    return null;
  }
  function skuLeiste(hoehe, istEck) { return "AL-" + hoehe + "-" + (istEck ? "ECK" : "STD"); }
  function skuTor(serie, torTyp, breite, torHoehe, farbe) {
    return "TOR-" + (serie === "Multi" ? "MUL" : "BAS") + "-" + (torTyp === "Doppeltor" ? "DOP" : "EIN") +
      "-" + breite + "-" + torHoehe + "-" + FARB_KUERZEL[farbe];
  }

  /* ---------- Verfügbare Optionen ermitteln ---------- */
  function mattenHoehen(z) {
    return HOEHEN.filter(function (h) { return skuMatte(z.staerke, h, z.farbe); });
  }
  function pfostenHoehen(z) {
    return HOEHEN.filter(function (h) { return skuPfosten(z.typ, h, z.farbe, z.montage); });
  }
  // Tor-Kombinationen aus den vorhandenen SKUs lesen (TOR-SER-TYP-BREITE-HOEHE-FARBE).
  function torKombis() {
    return Object.keys(V).filter(function (sku) { return sku.indexOf("TOR-") === 0 && verf(sku); })
      .map(function (sku) {
        var t = sku.split("-");
        return { sku: sku, serie: t[1], typ: t[2], breite: Number(t[3]), hoehe: Number(t[4]), farbe: t[5] };
      });
  }
  function torPasst(k, z) {
    return k.serie === (z.serie === "Multi" ? "MUL" : "BAS") &&
      k.typ === (z.torTyp === "Doppeltor" ? "DOP" : "EIN") &&
      k.farbe === FARB_KUERZEL[z.farbe];
  }
  function sichtGebinde(z) {
    var praefix = "SS-" + FORM_KUERZEL[z.form] + "-" + FARB_KUERZEL[z.farbe] + "-";
    return (DATEN.sicht || []).filter(function (e) {
      return e.sku && e.sku.indexOf(praefix) === 0 && verf(e.sku);
    }).map(function (e) { return { sku: e.sku, label: e.gebinde, preis: V[e.sku].preis }; });
  }

  /* ---------- Auswahl zu Warenkorbpositionen auflösen ---------- */
  function berechne(z) {
    var menge = Math.max(1, Math.floor(Number(z.menge) || 1));
    if (DATEN.art === "matten") {
      var ms = skuMatte(z.staerke, z.hoehe, z.farbe);
      if (!ms) return { ok: false };
      return { ok: true, positionen: [{ sku: ms, menge: menge }], einzelCent: V[ms].preis,
        name: "Doppelstabmatte 2,50 m · " + z.hoehe + " mm",
        details: z.farbe + " · " + z.staerke + " mm", bild: "fence-" + STAERKE_KUERZEL[z.staerke] + "-" + FARB_SLUG[z.farbe] + "-" + z.hoehe };
    }
    if (DATEN.art === "pfosten") {
      var ps = skuPfosten(z.typ, z.hoehe, z.farbe, z.montage);
      if (!ps) return { ok: false };
      var positionen = [{ sku: ps, menge: menge }];
      var einzel = V[ps].preis;
      var alHinweis = "";
      if (z.pfostenart === "Abdeckleiste") {
        var al = skuLeiste(z.hoehe, z.typ === "Eckpfosten");
        if (!verf(al)) return { ok: false };
        positionen.push({ sku: al, menge: menge });
        einzel += V[al].preis;
        alHinweis = " · mit Abdeckleiste";
      }
      var bildTyp = z.typ === "Eckpfosten" ? "eckpfosten" : "pfosten";
      var bildArt = z.pfostenart === "Abdeckleiste" ? "leiste" : "plaettchen";
      return { ok: true, positionen: positionen, einzelCent: einzel,
        name: z.typ + " für Mattenhöhe " + z.hoehe + " mm",
        details: z.farbe + " · " + z.montage + alHinweis, bild: bildTyp + "-" + bildArt + "-" + FARB_SLUG[z.farbe] };
    }
    if (DATEN.art === "tore") {
      var ts = skuTor(z.serie, z.torTyp, z.breite, z.torHoehe, z.farbe);
      if (!verf(ts)) return { ok: false };
      return { ok: true, positionen: [{ sku: ts, menge: menge }], einzelCent: V[ts].preis,
        name: z.serie + "-" + z.torTyp + " " + (z.breite / 1000).toLocaleString("de-DE") + " m breit",
        details: z.farbe + " · Höhe " + z.torHoehe + " mm · inkl. Pfosten, Schloss und Zubehör",
        bild: "gate-" + (z.serie === "Multi" ? "multi" : "basic") + "-" + (z.torTyp === "Doppeltor" ? "doppel" : "einzel") };
    }
    if (DATEN.art === "sicht") {
      if (!z.gebinde || !verf(z.gebinde)) return { ok: false };
      var g = sichtGebinde(z).filter(function (e) { return e.sku === z.gebinde; })[0];
      if (!g) return { ok: false };
      return { ok: true, positionen: [{ sku: z.gebinde, menge: menge }], einzelCent: g.preis,
        name: "Sichtschutzstreifen · " + g.label,
        details: z.farbe + " · " + z.form.toLowerCase(),
        bild: "sicht-" + z.form.toLowerCase() + "-" + FARB_SLUG[z.farbe] };
    }
    return { ok: false };
  }

  /* ---------- Oberfläche ---------- */
  function start() {
    var wurzel = document.querySelector("[data-schnellauswahl]");
    if (!wurzel || !DATEN.art) return;

    var zustand = { farbe: "Anthrazit", staerke: "6/5/6", hoehe: 1230, typ: "Zaunpfosten",
      montage: "Einbetonieren", pfostenart: "Abdeckplättchen", serie: "Basic", torTyp: "Einzeltor",
      breite: 0, torHoehe: 0, form: "Genarbt", gebinde: "", menge: 1 };
    var interagiert = false;

    var feld = function (name) { return wurzel.querySelector('[data-feld="' + name + '"]'); };

    function selectFuellen(name, werte, texte, bevorzugt) {
      var auswahl = feld(name);
      if (!auswahl) return "";
      var alt = auswahl.value;
      auswahl.innerHTML = werte.map(function (w, i) {
        return '<option value="' + esc(w) + '">' + esc(texte[i]) + "</option>";
      }).join("");
      if (werte.map(String).indexOf(String(alt)) >= 0) auswahl.value = alt;
      /* Umbau 08.10.2026: beim ersten Füllen ist alt leer, dann gilt der Startzustand (Höhe 1230) statt der ersten Option 630 */
      else if (bevorzugt != null && werte.map(String).indexOf(String(bevorzugt)) >= 0) auswahl.value = String(bevorzugt);
      return auswahl.value;
    }

    // Höhen-Kacheln (Relaunch 19.09.2026): Die Kacheln werden EINMAL gebaut (alle acht Höhen),
    // danach nur noch an- und abgewählt bzw. gesperrt. Würden sie bei jedem Zeichnen neu
    // gebaut, verlöre die Tastatur nach jedem Pfeiltasten-Schritt den Fokus.
    // Lieferbar ist genau, was im Auswahlfeld steht - das füllt selectFuellen wie bisher.
    function hoehenKacheln() {
      var ziel = wurzel.querySelector("[data-sa-hoehen]");
      var auswahl = feld("hoehe");
      if (!ziel || !auswahl) return;
      auswahl.classList.add("rz-wahl-ersatz");
      if (!ziel.children.length) {
        ziel.innerHTML = HOEHEN.map(function (h) {
          return '<label><input type="radio" name="sa-hoehe-kachel" value="' + h + '" data-sa-hoehe-kachel>' +
            '<span class="rz-kachel"><b>' + h + "</b><small>mm</small></span></label>";
        }).join("");
      }
      var lieferbar = Array.prototype.map.call(auswahl.options, function (o) { return o.value; });
      ziel.querySelectorAll("[data-sa-hoehe-kachel]").forEach(function (kachel) {
        kachel.disabled = lieferbar.indexOf(kachel.value) < 0;
        kachel.checked = !kachel.disabled && kachel.value === auswahl.value;
      });
    }

    // Knopf ausgrauen, wenn es mit diesem Wert keine einzige lieferbare Kombination gibt.
    function knopfVerfuegbar(wahl, wert) {
      var probe = Object.assign({}, zustand);
      probe[wahl] = wert;
      if (DATEN.art === "matten") return mattenHoehen(probe).length > 0;
      if (DATEN.art === "pfosten") {
        if (wahl === "pfostenart") return true; // Abdeckleisten-Verfügbarkeit meldet der Aufpreis-Text
        return pfostenHoehen(probe).length > 0;
      }
      if (DATEN.art === "tore") return torKombis().some(function (k) { return torPasst(k, probe); });
      if (DATEN.art === "sicht") return sichtGebinde(probe).length > 0;
      return true;
    }

    function knopfgruppeAktualisieren() {
      wurzel.querySelectorAll("[data-wahl]").forEach(function (knopf) {
        var wahl = knopf.dataset.wahl, wert = knopf.dataset.wert;
        knopf.classList.toggle("active", String(zustand[wahl]) === wert);
        knopf.disabled = !knopfVerfuegbar(wahl, wert);
      });
    }

    function zeichnen() {
      // Abhängige Auswahllisten immer aus den tatsächlich lieferbaren Kombinationen füllen.
      if (DATEN.art === "matten") {
        var mh = mattenHoehen(zustand);
        zustand.hoehe = Number(selectFuellen("hoehe", mh, mh.map(function (h) { return h + " mm"; }), zustand.hoehe)) || zustand.hoehe;
      }
      if (DATEN.art === "pfosten") {
        var ph = pfostenHoehen(zustand);
        zustand.hoehe = Number(selectFuellen("hoehe", ph, ph.map(function (h) { return h + " mm"; }), zustand.hoehe)) || zustand.hoehe;
        var alFeld = wurzel.querySelector("[data-sa-al-aufpreis]");
        if (alFeld) {
          var alSku = skuLeiste(zustand.hoehe, zustand.typ === "Eckpfosten");
          alFeld.textContent = verf(alSku) ? "· + " + geld(V[alSku].preis) + " je Pfosten" : "· aktuell nicht lieferbar";
        }
      }
      if (DATEN.art === "tore") {
        var kombis = torKombis();
        var breiten = [];
        kombis.filter(function (k) { return torPasst(k, zustand); }).forEach(function (k) {
          if (breiten.indexOf(k.breite) < 0) breiten.push(k.breite);
        });
        breiten.sort(function (a, b) { return a - b; });
        zustand.breite = Number(selectFuellen("breite", breiten, breiten.map(function (b) {
          return (b / 1000).toLocaleString("de-DE", { minimumFractionDigits: 1 }) + " m";
        }))) || zustand.breite;
        var hoehen = [];
        kombis.filter(function (k) { return torPasst(k, zustand) && k.breite === zustand.breite; }).forEach(function (k) {
          if (hoehen.indexOf(k.hoehe) < 0) hoehen.push(k.hoehe);
        });
        hoehen.sort(function (a, b) { return a - b; });
        zustand.torHoehe = Number(selectFuellen("torHoehe", hoehen, hoehen.map(function (h) { return h + " mm"; }))) || zustand.torHoehe;
      }
      if (DATEN.art === "sicht") {
        var gebinde = sichtGebinde(zustand);
        zustand.gebinde = selectFuellen("gebinde", gebinde.map(function (g) { return g.sku; }),
          gebinde.map(function (g) { return g.label + " · " + geld(g.preis); })) || "";
      }

      hoehenKacheln();
      knopfgruppeAktualisieren();

      var r = berechne(zustand);
      var bildFeld = wurzel.querySelector("[data-sa-bild]");
      var nameFeld = wurzel.querySelector("[data-sa-name]");
      var detailFeld = wurzel.querySelector("[data-sa-details]");
      var preisFeld = wurzel.querySelector("[data-sa-preis]");
      var korbKnopf = wurzel.querySelector("[data-sa-korb]");
      var leiste = wurzel.querySelector("[data-sa-leiste]");
      var leisteWert = wurzel.querySelector("[data-sa-leiste-wert]");

      if (r.ok) {
        var gesamt = r.einzelCent * Math.max(1, Math.floor(Number(zustand.menge) || 1));
        if (nameFeld) nameFeld.textContent = r.name;
        if (detailFeld) detailFeld.textContent = r.details;
        if (preisFeld) preisFeld.textContent = geld(gesamt);
        if (leisteWert) leisteWert.textContent = geld(gesamt);
        if (korbKnopf) korbKnopf.disabled = false;
        if (bildFeld) {
          var url = BILDER[r.bild] || "";
          bildFeld.hidden = !url;
          if (url) { bildFeld.src = url; bildFeld.alt = r.name; }
        }
      } else {
        if (nameFeld) nameFeld.textContent = "Diese Kombination ist nicht lieferbar";
        if (detailFeld) detailFeld.textContent = "Bitte wählen Sie eine andere Ausführung oder fragen Sie uns per WhatsApp.";
        if (preisFeld) preisFeld.textContent = "–";
        if (leisteWert) leisteWert.textContent = "–";
        if (korbKnopf) korbKnopf.disabled = true;
        if (bildFeld) bildFeld.hidden = true;
      }
      if (leiste) leiste.hidden = !interagiert;
    }

    function melden(text, fehler) {
      var meldung = wurzel.querySelector("[data-sa-meldung]");
      if (!meldung) return;
      meldung.hidden = false;
      meldung.className = "korb-status" + (fehler ? " fehler" : "");
      meldung.innerHTML = text;
    }

    function inDenKorb() {
      var r = berechne(zustand);
      if (!r.ok) { melden("Diese Kombination ist nicht lieferbar.", true); return; }
      var knoepfe = wurzel.querySelectorAll("[data-sa-korb], [data-sa-leiste-korb]");
      knoepfe.forEach(function (k) { k.disabled = true; });
      melden("Wird in den Warenkorb gelegt …", false);
      var artikel = r.positionen.map(function (p) {
        return { id: V[p.sku].id, quantity: p.menge, properties: { "Ausführung": r.name + " · " + r.details } };
      });
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: artikel })
      }).then(function (antwort) {
        return antwort.json().then(function (daten) {
          if (!antwort.ok) throw new Error(daten.description || daten.message || "Der Warenkorb hat die Position abgelehnt.");
          return daten;
        });
      }).then(function () {
        melden('Liegt im Warenkorb. <a href="/cart">Zum Warenkorb und zur Kasse →</a>', false);
        knoepfe.forEach(function (k) { k.disabled = false; });
        if (window.RostKorb) window.RostKorb.oeffnen();
      }).catch(function (fehler) {
        melden("Das hat nicht geklappt: " + esc(fehler.message), true);
        knoepfe.forEach(function (k) { k.disabled = false; });
      });
    }

    wurzel.addEventListener("click", function (ereignis) {
      var knopf = ereignis.target.closest("[data-wahl]");
      if (knopf && !knopf.disabled) {
        zustand[knopf.dataset.wahl] = knopf.dataset.wert;
        interagiert = true;
        zeichnen();
        return;
      }
      if (ereignis.target.closest("[data-sa-korb], [data-sa-leiste-korb]")) inDenKorb();
    });
    wurzel.addEventListener("input", function (ereignis) {
      // Höhen-Kachel: setzt nur den Wert des Auswahlfelds, alles Weitere läuft wie bei
      // einer Wahl im Auswahlfeld selbst.
      var kachel = ereignis.target.closest("[data-sa-hoehe-kachel]");
      if (kachel) {
        var hoehenFeld = feld("hoehe");
        if (hoehenFeld) hoehenFeld.value = kachel.value;
        zustand.hoehe = Number(kachel.value) || zustand.hoehe;
        interagiert = true;
        zeichnen();
        return;
      }
      var ziel = ereignis.target.closest("[data-feld]");
      if (!ziel) return;
      var name = ziel.dataset.feld;
      zustand[name] = name === "gebinde" ? ziel.value : (Number(ziel.value) || ziel.value);
      interagiert = true;
      zeichnen();
    });

    zeichnen();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
